<ng-content></ng-content>

<tbx-icon class="caret-down" name="caret-down"></tbx-icon>
